import { render, staticRenderFns } from "./App.vue?vue&type=template&id=dd47c2ee&"
var script = {}
import style0 from "@/assets/css/reset.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/global.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports